import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "styled-components";
import { token } from "./token.js";
import { Dropdown } from "./Dropdown.js";
import { Divider } from "./Divider2.js";
import { ToolbarButton } from "./ToolbarButton.js";
import { ToolbarContext } from "./context9.js";
function Toolbar({
  direction = "horizontal",
  isSmall = false,
  children
}) {
  const contextValue = useMemo(() => {
    return {
      direction,
      isSmall
    };
  }, [direction, isSmall]);
  return /* @__PURE__ */ jsx(ToolbarContext.Provider, {
    value: contextValue,
    children: /* @__PURE__ */ jsx(Dropdown.OffsetContext.Provider, {
      value: "extra",
      children: /* @__PURE__ */ jsx(Container, {
        $direction: direction,
        children
      })
    })
  });
}
Toolbar.Divider = Divider;
Toolbar.Button = ToolbarButton;
const Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1s8e8x3-0"
})(["display:flex;flex-direction:", ";box-sizing:border-box;width:min-content;margin:", ";padding:", ";border-radius:", ";background:", ";box-shadow:", ",", ";"], (props) => props.$direction === "vertical" ? "column" : "row", token.spacing3, (props) => props.$direction === `vertical` ? `${token.spacing3} ${token.spacing2}` : `${token.spacing2} `, token.radiusLarge, token.white, token.elevation2, token.elevationStatic);
export {
  Toolbar
};
//# sourceMappingURL=Toolbar.js.map
